var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBiTrash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.2 5.4a.4.4 0 01.4.4v4.8a.4.4 0 11-.8 0V5.8a.4.4 0 01.4-.4zm2 0a.4.4 0 01.4.4v4.8a.4.4 0 11-.8 0V5.8a.4.4 0 01.4-.4zm2.4.4a.4.4 0 00-.8 0v4.8a.4.4 0 10.8 0V5.8z",
    fill: "#343434"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4 3.4a.8.8 0 01-.8.8h-.4v7.2A1.6 1.6 0 019.6 13H4.8a1.6 1.6 0 01-1.6-1.6V4.2h-.4a.8.8 0 01-.8-.8v-.8a.8.8 0 01.8-.8h2.8a.8.8 0 01.8-.8H8a.8.8 0 01.8.8h2.8a.8.8 0 01.8.8v.8zm-8.306.8L4 4.247V11.4a.8.8 0 00.8.8h4.8a.8.8 0 00.8-.8V4.247l-.094-.047H4.094zM2.8 3.4v-.8h8.8v.8H2.8z",
    fill: "#343434"
  })));
}
export default SvgBiTrash;